import { Grid, Typography } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { errorsFormRegisterState } from '../../state/atoms';
import RutField from '../../components/RutField';
import NamesField from '../../components/NamesField';
import LastnamePatField from '../../components/LastnamePatField';
import LastnameMatField from '../../components/LastnameMatField';
import BirthDateField from '../../components/BirthDateField';
import GeneroAutocomplete from '../../components/GeneroAutocomplete';
import PrevisionAutocomplete from '../../components/PrevisionAutocomplete';
import EmailField from '../../components/EmailField';
import PhoneMobileField from '../../components/PhoneMobileField';
import LandlineField from '../../components/LandlineField';
import InputLabelCustom from "src/shared/components/forms/InputLabelCustom"

const FormCompleteInformation = () => {
    const { phoneEmpty } = useRecoilValue(errorsFormRegisterState);

    return (
        <>
            <Grid container spacing={2}>
                <Grid item md={6} xs={12}>
                    <RutField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <NamesField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <LastnamePatField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <LastnameMatField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <BirthDateField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <GeneroAutocomplete />
                </Grid>

                <Grid item md={6} xs={12}>
                    <InputLabelCustom htmlFor="autcomplete-prevision" text="Previsión (Opcional)" />
                    <PrevisionAutocomplete />
                </Grid>

                <Grid item md={6} xs={12}>
                    <EmailField />
                </Grid>

                <Grid item md={6} xs={12}>
                    <PhoneMobileField />
                </Grid>
                <Grid item container md={6} xs={12}>
                    <LandlineField />
                </Grid>
                {
                    phoneEmpty.length > 0 && (
                        <Grid item xs={12} md={12} display={"flex"} justifyContent={"center"}>
                            <Typography color="error" fontSize={"0.75rem"}>{phoneEmpty.join("\n")}</Typography>
                        </Grid>
                    )
                }
            </Grid>
        </>
    )
}

export default FormCompleteInformation;